import { useEffect } from "react";
import Icon from "./Icon";

// Ventana modal del panel. Se cierra con Escape, tocando afuera o con la cruz.
const Dialog = ({ open, title, onClose, children, wide, className = "" }) => {

    useEffect(() => {
        if (!open) return;
        const onKey = (e) => e.key === "Escape" && onClose();
        document.addEventListener("keydown", onKey);
        document.body.style.overflow = "hidden";
        return () => {
            document.removeEventListener("keydown", onKey);
            document.body.style.overflow = "";
        };
    }, [open, onClose]);

    if (!open) return null;

  return (
    <div className="lp-panel-overlay" onClick={onClose}>
        <div className={(wide ? "lp-panel-dialog lp-panel-dialog-wide " : "lp-panel-dialog ") + className} role="dialog" aria-modal="true" aria-label={title} onClick={(e) => e.stopPropagation()}>
            <div className="lp-panel-dialog-head">
                <h2>{title}</h2>
                <button type="button" className="lp-panel-icon-btn" onClick={onClose} aria-label="Cerrar"><Icon name="close"></Icon></button>
            </div>
            {children}
        </div>
    </div>
  )
}

export default Dialog
